import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import Box from "@material-ui/core/Box";
import clsx from "clsx";
import VesselsUnderContract from "./VesselsUnderContract";
import SalesAgreementLines from "./SalesAgreementLines";
import AdditionalTestParameters from "./AdditionalTestParameters";
import VPSSalesPerson from "./VPSSalesPerson";

const useStyles = makeStyles((theme) => ({
  contractMenu: {
    fontSize: 18,
    cursor: "pointer",
  },
  active: {
    color: "#ff4717",
  },
  leftBoxContract: {
    borderRight: "1px solid #979797",
  },
  tableLayoutBox:{
    marginBottom:"30px"
  }
}));
export default function ContractDetails(props) {
  const { row } = props;
  const [activeKey, setActiveKey] = useState("SalesAgreementLines");
  const classes = useStyles();

  return (
    <React.Fragment>
      <Grid container className={classes.tableLayoutBox}>
        <Grid item md={4} sm={12} className={classes.leftBoxContract}>
          <Box className="cc-table" py={2} px={4}>
            <Typography
              variant="h6"
              className={clsx(
                classes.contractMenu,
                activeKey === "SalesAgreementLines" ? classes.active : ""
              )}
              gutterBottom
              component="div"
              onClick={() => {
                setActiveKey("SalesAgreementLines");
              }}
            >
              <Box pb={2} alignItems="center" display="flex">
                Sales Agreement Lines <ArrowRightIcon />
              </Box>
            </Typography>
            <Typography
              variant="h6"
              className={clsx(
                classes.contractMenu,
                activeKey === "AdditionalTestParameters" ? classes.active : ""
              )}
              gutterBottom
              component="div"
              onClick={() => {
                setActiveKey("AdditionalTestParameters");
              }}
            >
              <Box pb={2} alignItems="center" display="flex">
                Additional Test Parameters <ArrowRightIcon />
              </Box>
            </Typography>
            <Typography
              variant="h6"
              className={clsx(
                classes.contractMenu,
                activeKey === "VesselsUnderContract" ? classes.active : ""
              )}
              gutterBottom
              component="div"
              onClick={() => {
                setActiveKey("VesselsUnderContract");
              }}
            >
              <Box pb={2} alignItems="center" display="flex">
                Assets Under Contract <ArrowRightIcon />
              </Box>
            </Typography>
            <Typography
              variant="h6"
              className={clsx(
                classes.contractMenu,
                activeKey === "VPSSalesPerson" ? classes.active : ""
              )}
              gutterBottom
              component="div"
              onClick={() => {
                setActiveKey("VPSSalesPerson");
              }}
            >
              <Box alignItems="center" display="flex">
                VPS Sales Person <ArrowRightIcon />
              </Box>
            </Typography>
          </Box>
        </Grid>
        <Grid item sm={12} md={8}>
          <Box py={2} px={4}>
            {activeKey === "SalesAgreementLines"?(
            <SalesAgreementLines rows={row} onActiveKey = {activeKey} />):
            activeKey === "VesselsUnderContract"?(
            <VesselsUnderContract rows={row} onActiveKey = {activeKey} />
            ):activeKey === "AdditionalTestParameters"?(              
            <AdditionalTestParameters rows={row} onActiveKey = {activeKey} />
            ):activeKey === "VPSSalesPerson"?(              
              <VPSSalesPerson rows={row} onActiveKey = {activeKey} />
              ):""}
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
